import { FileUploadComponent } from './file-upload/file-upload.component';
import { CarouselComponent } from './carousel/carousel.component';
import { LayoutService } from './../services/layout.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbLayoutModule,
  NbSidebarModule,
  NbButtonModule,
  NbToggleModule,
  NbActionsModule,
  NbUserModule,
  NbSelectModule,
  NbIconModule,
  NbMenuModule,
  NbContextMenuModule,
  NbAlertModule,
  NbInputModule,
  NbCardModule,
  NbFormFieldModule,
  NbBadgeModule,
  NbListModule
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { RouterModule } from '@angular/router';
import { HoursStatusComponent } from './hours-status/hours-status.component';
import { DropzoneDirective } from './directives/dropzone.directive';
import { ConnectLinkComponent } from './connect-link/connect-link.component';
import { DocScrollerComponent } from './doc-scroller/doc-scroller.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { AltMenuComponent } from './alt-menu/alt-menu.component';
import { DeleteButtonComponent } from './delete-button/delete-button.component';
import { AdUnitComponent } from './ad-unit/ad-unit.component';

const components = [
  CarouselComponent,
  HoursStatusComponent,
  FileUploadComponent,
  DropzoneDirective,
  ConnectLinkComponent,
  BreadcrumbsComponent,
  DocScrollerComponent,
  AltMenuComponent
];
const modules = [
  CommonModule,
  RouterModule,
  ScrollingModule,
  FormsModule,
  NbListModule,
  NbLayoutModule,
  NbFormFieldModule,
  NbBadgeModule,
  NbIconModule,
  NbUserModule,
  NbActionsModule,
  NbCardModule,
  NbMenuModule,
  NbEvaIconsModule,
  NbInputModule,
  NbToggleModule,
  NbActionsModule,
  NbButtonModule,
  NbSidebarModule,
  NbSelectModule,
  NbAlertModule,
  NbContextMenuModule
];

@NgModule({
  declarations: [...components],
  imports: [...modules, DeleteButtonComponent, AdUnitComponent],
  exports: [...components, DeleteButtonComponent, AdUnitComponent],
  providers: [LayoutService]
})
export class SharedModule {}
